import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HorizontalAlignmentOptions } from '@df/ui/atomic/atomic-options';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NTextComponent } from '../../common/text/text.component';
import { defaultImage } from '../../icms.config';
let uid = 0;
export namespace NCmsCategoryCarousel {
    export interface IComponentData extends NICmsContentComponent.IData, NTextComponent.ITextContent {
        categories: ICategoryCarousel[];
        categoryTextAlign?: 'left' | 'center' | 'right';
        textOverImage?: boolean;
        displayGrid?: boolean;
    }
    export interface ICategoryCarousel {
        title: string;
        subtitle?: string;
        buttons?: IButtons[];
        viewAllLink?: string;
        viewAllText?: string;
        link?: string;
        image: string;
    }

    export interface IButtons {
        buttonCopy: string;
        link: string;
    }
}

@ICmsComponent<CmsCategoryCarouselComponent>({
    id: 'category-carousel',
    name: 'Category carousel',
    tags: ['categories', 'carousel', 'links'],
    fields: [
        ...NTextComponent.getFields(false, true),
        <NICmsContentField.IToggleField>{
            key: 'displayGrid',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Display as grid or carousel',
            labels: { true: 'Grid', false: 'Carousel' },
            default: false
        },
        <NICmsContentField.IChoiceField>{
            key: 'categoryTextAlign',
            type: NICmsContentField.EFieldType.choice,
            title: 'Category text align',
            options: HorizontalAlignmentOptions,
            default: 'left'
        },
        {
            key: 'textOverImage',
            type: NICmsContentField.EFieldType.toggle,
            title: 'Text over category image',
            default: false
        },
        // links
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'categories',
            title: 'Categories',
            itemName: 'Category',
            itemNameField: 'title',
            required: true,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Title',
                    default: 'Lorem Ipsum dolor',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'subtitle',
                    title: 'Subtitle',
                    default: 'Lorem ipsum dolor sit amet, consectetur elit.'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'link',
                    title: 'Link',
                    default: '/',
                    description: 'Link added on image'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Image',
                    default: defaultImage,
                    required: true
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'buttons',
                    title: 'Buttons',
                    description: 'Only for the grid variant',
                    itemName: 'Button',
                    itemNameField: 'buttonCopy',
                    fields: [
                        <NICmsContentField.IField>{
                            type: NICmsContentField.EFieldType.text,
                            key: 'buttonCopy',
                            title: 'Button copy',
                            default: 'View',
                            required: true
                        },
                        <NICmsContentField.IField>{
                            type: NICmsContentField.EFieldType.text,
                            key: 'link',
                            title: 'Link',
                            default: '/',
                            required: true
                        }
                    ]
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'viewAllLink',
                    title: 'View all link',
                    default: '/'
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'viewAllText',
                    title: 'View all text',
                    default: 'VIEW ALL'
                }
            ],
            defaultSize: 6
        }
    ]
})
@Component({
    selector: 'cms-category-carousel',
    templateUrl: './cms-category-carousel.html',
    styleUrls: ['./cms-category-carousel.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsCategoryCarouselComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsCategoryCarousel.IComponentData;

    protected uid = uid++;

    get pcSlides() {
        return [1.15, 2.15, 4.25, 5.2][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return [8, 8, 16, 16][this.client.sizeId] + 'px';
    }
}
